import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { resetActiveOrderHistory } from '@kfc-global/react-shared/redux/Actions/OrderHistoryAction';

import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';
import {
  clearDispatchGetActiveOrderHistoryTimer,
  dispatchGetActiveOrderHistory,
  updateHeaderTrackDetailsWithOrderHistoryReducer,
} from 'organisms/HeaderTrackOrderComponent/utils/HeaderTrackOrderUtils';
import {
  validateAndGetPostActiveOrderHistoryDetailsList,
  updatePickupOrderStateValue,
} from '../../utils/HeaderTrackOrderUtils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { SESSION_STORAGE_KEYS, ROUTE_URL } from 'common/constants/SharedConstants';

const getHeaderTrackOrderItems = params => {
  return (
    <LazyLoaderWrapper
      {...params}
      testId='app_header_order_tracker_view'
      importPath='APP_HEADER_ORDER_TRACKER_VIEW'
    ></LazyLoaderWrapper>
  );
};

const HeaderTrackOrderComponent = props => {
  const dispatch = useDispatch();
  const { tenantReducer, orderHistoryReducer, profileReducer, appStateReducer } = useSelector(data => data);
  const location = useLocation();

  const [headerTrackDetails, setHeaderTrackDetails] = useState({
    trackOrderTitle: '',
    trackOrderButtonLabel: '',
    isActiveOrderAvailable: false,
    useHistoryHook: { history: useHistory() },
    dispatchGetActiveOrderHistoryTimer: null,
    dispatch,
    props,
    customerId: null,
    tenantId: null,
    postActiveOrderHistoryDetailsList: [],
    customer: null,
    showBlackStripWithOrderTracker: false,
    showPickupOrderCancelledBanner: false,
    pickupOrderCancelledTitle: translateWithI18Next(TRANSLATE_MAPPING_KEY?.PICKUP_CANCALLED_ORDER),
    pickupOrderCancelledButtonLabel: translateWithI18Next(TRANSLATE_MAPPING_KEY?.ORDER_HISTORY_TAG),
  });

  const updateSetHeaderTrackDetails = useCallback(param => {
    setHeaderTrackDetails && setHeaderTrackDetails(prevState => ({ ...prevState, ...param }));
  }, []);

  useEffect(() => {
    clearDispatchGetActiveOrderHistoryTimer({ headerTrackDetails, updateSetHeaderTrackDetails });
    dispatch(resetActiveOrderHistory());

    return () => clearDispatchGetActiveOrderHistoryTimer({ headerTrackDetails, updateSetHeaderTrackDetails });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    clearDispatchGetActiveOrderHistoryTimer({ headerTrackDetails, updateSetHeaderTrackDetails });
    tenantReducer?.tenantId &&
      updateSetHeaderTrackDetails({
        customerId: profileReducer?.customerId,
        customer: profileReducer?.basic,
        tenantId: tenantReducer?.tenantId,
        userStatus: appStateReducer?.userStatus,
        showBlackStripWithOrderTracker: tenantReducer?.componentOptions?.web?.global?.showBlackStripWithOrderTracker,
        enableGlobalOrderTracking: tenantReducer?.componentOptions?.web?.orderPages?.enableGlobalOrderTracking,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileReducer?.customerId, tenantReducer?.tenantId, appStateReducer?.userStatus]);

  useEffect(() => {
    dispatchGetActiveOrderHistory({ headerTrackDetails });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerTrackDetails?.customerId, headerTrackDetails?.tenantId, location?.pathname]);

  useEffect(() => {
    if (
      headerTrackDetails?.userStatus?.loggedIn &&
      orderHistoryReducer &&
      orderHistoryReducer?.activeOrderHistory &&
      !orderHistoryReducer?.activeOrderHistoryLoading &&
      orderHistoryReducer?.activeOrderHistory?.length > 0
    ) {
      const postActiveOrderHistoryDetailsList = validateAndGetPostActiveOrderHistoryDetailsList(
        orderHistoryReducer?.activeOrderHistory,
      );
      if (
        postActiveOrderHistoryDetailsList?.length > 0 &&
        headerTrackDetails?.showBlackStripWithOrderTracker === false
      ) {
        props.setShowBlackStripeContent(false);
      } else if (
        postActiveOrderHistoryDetailsList?.length === 0 &&
        headerTrackDetails?.showPickupOrderCancelledBanner === false
      ) {
        props.setShowBlackStripeContent(true);
      }
      updateSetHeaderTrackDetails({ postActiveOrderHistoryDetailsList });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderHistoryReducer?.activeOrderHistory, headerTrackDetails?.userStatus?.loggedIn]);

  useEffect(() => {
    if (
      sessionStorage.getItem(SESSION_STORAGE_KEYS.PICKUP_ORDER_CANCELLED) &&
      (location?.pathname === ROUTE_URL.HOME || location?.pathname === ROUTE_URL.HOME_PAGE)
    ) {
      updateSetHeaderTrackDetails({ showPickupOrderCancelledBanner: true });
      headerTrackDetails?.showBlackStripWithOrderTracker === false && props.setShowBlackStripeContent(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerTrackDetails?.showBlackStripWithOrderTracker]);

  useEffect(() => {
    updatePickupOrderStateValue({ headerTrackDetails, location, updateSetHeaderTrackDetails, props });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.pathname]);

  useEffect(() => {
    headerTrackDetails?.userStatus?.loggedIn &&
      updateHeaderTrackDetailsWithOrderHistoryReducer({
        headerTrackDetails,
        updateSetHeaderTrackDetails,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerTrackDetails?.postActiveOrderHistoryDetailsList]);

  return (
    (headerTrackDetails?.isActiveOrderAvailable || headerTrackDetails?.showPickupOrderCancelledBanner) &&
    getHeaderTrackOrderItems({ headerTrackDetails, updateSetHeaderTrackDetails })
  );
};

export default HeaderTrackOrderComponent;
